import { LoadingPage } from '@src/common/components/LoadingPage';
import { useReviewableOrder } from '@src/orders/hooks/useReviewableOrder';
import { OrderReview } from '@src/orders/review/OrderReview';
import { useTranslation } from 'react-i18next';

interface Props {
  orderId: string;
}

export const OrderReviewLoader = ({ orderId }: Props) => {
  const { t } = useTranslation();

  const { isLoading: isOrderLoading, order } = useReviewableOrder({
    id: orderId,
  });

  if (isOrderLoading) {
    return <LoadingPage />;
  }

  if (!order) {
    return <>{t('loadingError')}</>;
  }

  return <OrderReview order={order} />;
};
